import * as React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Container from 'components/Container'
import Html from 'components/Html'
import Section from 'components/Section'

export const useStyles = makeStyles((theme) => ({
  root: {
    '@global': {
      'h1, h2, h3, h4, h5, h6, p, ol, ul, blockquote': {
        // maxWidth: 'var(--coa-content-max-width)',
      },
      figure: {
        // marginLeft: 'calc(var(--coa-container-spacing, 0px) * -1)',
        // marginRight: 'calc(var(--coa-container-spacing, 0px) * -1)',
      },
      'figure img': {
        width: '100%',
      },
      '.wp-block-video, .wp-block-embed__wrapper': {
        display: 'block',
        position: 'relative',
        width: '100%',
        '&::before': {
          content: '""',
          display: 'block',
          paddingBottom: 'calc(9/16 * 100%)', // 16:9 aspect ratio
        },
        '& > *': {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        },
        '& > video, & > picture, & > img': {
          // ⚠️ object-fit is not supported by IE 11.
          objectfit: 'cover',
        },
      },
    },
  },
  content: theme.mixins.contain('var(--coa-content-max-width)'),
}))

function Content(props) {
  const { children, className, content } = props
  const classes = useStyles(props)

  const componentProps = {}
  if (content) {
    componentProps.dangerouslySetInnerHTML = { __html: content }
  } else {
    componentProps.children = children
  }

  return (
    <Section className={clsx(classes.root, className)} gutters="margin">
      <Container maxWidth={false}>
        <Html className={classes.content} {...componentProps} />
      </Container>
    </Section>
  )
}

Content.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default Content
